import * as History from "history";
import * as Store from "store";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import App from "App";
import Platforms from "utils/Platforms";
import React from "react";
import ReactDom from "react-dom";

export default class Main {
  static initApp(rootNode) {
    if (Platforms.checkIsTouchDevice()) {
      window.document.body.dataset.mobile = "";
    } else {
      window.document.body.dataset.desktop = "";
    }
    this.history = History.createBrowserHistory();
    this.store = Store.createStore({ history: this.history });
    Main.renderApp(rootNode);
  }

  static renderApp(rootNode) {
    ReactDom.render(
      <Provider store={this.store}>
        <ConnectedRouter history={this.history}>
          <App />
        </ConnectedRouter>
      </Provider>,
      rootNode
    );
  }
}
